<template>
  <div class="payment-success">
    <NavBar />
    <div class="success-content">
      <h1>{{ message }}</h1>
      <div v-if="creditsAdded" class="credits-info">
        <p>✅ {{ creditsAdded }} hour credits have been added to your account!</p>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

export default {
  name: "PaymentSuccess",
  components: { NavBar },
  data() {
    return {
      message: "Checking payment status...",
      creditsAdded: 0
    };
  },
  async mounted() {
    const sessionId = this.$route.query.session_id;
    
    if (sessionId) {
      try {
        // Call our backend to process the payment and add credits
        const response = await fetch(`${API_BASE}/process-payment-success/${sessionId}`, {
          method: 'POST',
          credentials: 'include'
        });
        
        const data = await response.json();
        
        if (data.success) {
          this.message = "Payment successful!";
          this.creditsAdded = data.credits_added;
        } else {
          this.message = "Payment successful, but there was an issue adding credits. Please contact support.";
        }
      } catch (error) {
        console.error('Error processing payment:', error);
        this.message = "Payment successful, but there was an issue adding credits. Please contact support.";
      }
    } else {
      this.message = "Payment successful!";
    }
  },
};
</script>

<style scoped>
.payment-success {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-family: "Inter", sans-serif;
  padding: 2rem;
}

.credits-info {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  color: #155724;
}
</style>
